import { PropsWithChildren } from 'react';
import { ReactComponent as ArrowDownIcon } from '../../icons/chevron-down.svg';
import './HoverDropdown.scss';

interface Props {
  className?: string;
  trigger: JSX.Element;
  arrow?: boolean;
}

export default function HoverDropdown({
  className = '',
  trigger,
  children,
  arrow = true,
}: PropsWithChildren<Props>) {
  return (
    <div className={`HoverDropdown ${className}`}>
      <div className='d-flex align-items-center HoverDropdown__trigger'>
        {trigger}
        {arrow && <ArrowDownIcon className='HoverDropdown__arrow' />}
      </div>
      <div className='HoverDropdown__menu'>
        <div className='HoverDropdown__content'>{children}</div>
      </div>
    </div>
  );
}
